<template>
  <v-hover v-slot="{ hover }" :open-delay="0" :close-delay="25">
    <li
      class="base-list-item f14 py-4 px-7"
      :class="
        (hover ? 'primary white--text pointer' : 'primary--text white') +
        ' ' +
        (uppercase ? 'uppercase' : '')
      "
      @click="item.click ? item.click() : undefined"
    >
      {{ item.title }}
    </li>
  </v-hover>
</template>
<script>
export default {
  name: 'BaseListItem',
  props: { item: Object, uppercase: Boolean },
  data() {
    return { delay: 50 }
  },
  methods: {},
}
</script>

<style lang="scss" scoped></style>
